<template>
  <div>
    <v-row dense class="mx-1">
      <px-cadastro-departamento @change="onClickRefresh">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on">
            <v-icon left>mdi-plus</v-icon>
            Departamento
          </v-btn>
        </template>
      </px-cadastro-departamento>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por um departamento" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import CadastroDepartamento from './CadastroDepartamento.vue';

export default {
  methods: {
    onClickRefresh() {
      this.$emit('refresh');
    },
    onChangeSearchText() {
      this.$emit('change', this.buildFilter());
    },
    buildFilter() {
      let filter = '';
      if (this.searchText) {
        filter += `descricao like '%${this.searchText.replaceAll('"', '\\"').replaceAll('\'', '\\\'').toLowerCase()}%'`;
      }
      return filter;
    },
  },
  data() {
    return {
      searchText: null,
    };
  },
  components: {
    pxCadastroDepartamento: CadastroDepartamento,
  },
};
</script>
